export default {
  title: 'Verify it’s you',
  text: 'An SMS with a 4-digit verification code has been sent to the phone number ending in ',
  successSendCode: 'New code has been sent',
};
